<template>
  <v-dialog v-model="dlgVisivel" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">{{titulo}}</v-card-title>
      <v-card-text>{{texto}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="cancelar">{{txtCancelar}}</v-btn>
        <v-btn color="success" :disabled="btnConfirmarDisabled" text @click="confirmar">{{txtConfirmar}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
     visivel: {
      type: Boolean,
      required: true,
    },
    texto: {
      type: String,
      required: true
    }, 
    titulo: {
      type: String,
      default: 'Confirmação'
    },
    txtConfirmar: {
      type: String,
      default: 'Confirmar'
    },
    txtCancelar: {
      type: String,
      default: 'Cancelar'
    }
  },
  data() {
    return {
      btnConfirmarDisabled: false,
    }
  },
  computed: {
      dlgVisivel: {
           get(){
             return this.visivel
           },
           set(newVal){
             return newVal
           } 
        }
  },
  watch: {
    visivel: function () {
      this.btnConfirmarDisabled = false;
    },
  },
  methods: {
    cancelar() {
      this.$emit("cancelar");
      this.btnConfirmarDisabled = false;
    },
    confirmar() {
      this.btnConfirmarDisabled = true;
      this.$emit("confirmar");
    },
  },
};
</script>